export default {
  label: {
    listening: {
      title: 'Filtro Não-proprietário',
    },
    sac: {
      title: 'Filtro Proprietário',
    },
    page: {
      title: 'Filtro de Páginas',
    },
    sacStatus: {
      title: 'Filtro de Atendimento',
    },
    comparative: {
      title: 'Filtro de Comparativo',
    },
    category: {
      title: 'Categoria',
      placeholder: 'Nenhum',
    },
    sacListening: {
      title: 'Filtro Proprietário + Não-proprietários',
      listeningSession: 'Não-proprietários',
      sacSession: 'Proprietários',
    },
    button: {
      applyLabel: 'Aplicar',
      clearFilter: 'Limpar todo o filtro',
      clearchange: 'Reverter mudanças recentes',
    },
  },
};
